/* jshint esversion: 8 */
/* jshint node: true */

import React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";

const IndiaFootnote = ({ isHidden = false }) => {
  return (
    <Box
      sx={{ fontSize: "0.6rem", marginBottom: "1rem", fontStyle: "italic" }}
      tabIndex={isHidden ? -1 : 1}
      role="note"
    >
      India's FY25 Q4 data exclude Maharashtra and Telangana states due to award transitions. These two states accounted for approximately 169,000 (38%) of India's FY24 PEPFAR treatment cohort. As of September 30, 2025, the Government of India continued to support 166,640 individuals on current treatment in these two States at the 52 ART centers that were previously partially PEPFAR-funded. These 166,640 individuals are excluded from all numbers in the Q4 2025 data, as historically PEPFAR only reports on individuals receiving treatment at sites that are funded by PEPFAR. Had the 166,640 individuals been included, the total number of individuals on treatment in Q4 2025 would have been 20.7M, an increase of 100k from Q4 2024.
    </Box>
  );
};

IndiaFootnote.propTypes = {
  isHidden: PropTypes.bool,
};

export default IndiaFootnote;
